<template>
  <div id="app">
    <div class="do-it" />
  </div>
</template>

<script>
export default {
  components: {
  },
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  overflow: hidden;
}


.do-it {
  height: 100%;
  background: #999 url('./assets/do-it-2.png') 50% 50% no-repeat;
  background-size: contain;
  cursor: pointer;
}

.do-it:active {
  background-image: url('./assets/do-it-1.png');
  background-color: #900;
  animation: 0.15s linear triggered infinite;
}

@keyframes triggered {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}
</style>
